//@flow
import * as React from 'react'

import { useSubheadingStyles } from './styles'

type SubheadingProps = {
  children: React.Node
}

const Subheading = ({ children, ...props }: SubheadingProps) => {
  const classes = useSubheadingStyles()
  return (
    <p className={classes.subheadingWrapper} {...props}>
      {children}
    </p>
  )
}
export default Subheading
